import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams, useNavigate } from "react-router-dom";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function EditProductionOrder() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [WCs, setWCs] = useState([]);

  const [data, setData] = useState({
    order_no: "",
    product_id: "",
    quantity: "",
    start_date: "",
    end_date: "",
    workcenter_id: ""
  });

  useEffect(() => {
    fetchOrder();
    fetchProducts();
    fetchWCs();
  }, []);

  // Fetch ProductionOrder details
  const fetchOrder = () => {
    axios.get(baseUrl + "production-orders/" + id + "/")
      .then(res => {
        setData({
          order_no: res.data.order_no || "",
          product_id: res.data.product?.id || "",
          quantity: res.data.quantity || "",
          start_date: res.data.start_date || "",
          end_date: res.data.end_date || "",
          workcenter_id: res.data.workcenter?.id || ""
        });
      })
      .catch(() => Swal.fire("Error", "Could not fetch Production Order", "error"));
  };

  const fetchProducts = () => {
    axios.get(baseUrl + "products/")
      .then(res => setProducts(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch Products", "error"));
  };

  const fetchWCs = () => {
    axios.get(baseUrl + "workcenters/")
      .then(res => setWCs(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch Work Centers", "error"));
  };

  const inputHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const formSubmit = () => {
    if (!data.order_no || !data.product_id || !data.quantity || !data.start_date || !data.workcenter_id) {
      Swal.fire("Error", "Please fill all required fields", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("order_no", data.order_no);
    _formData.append("product", data.product_id);
    _formData.append("quantity", data.quantity);
    _formData.append("start_date", data.start_date);
    if (data.end_date) _formData.append("end_date", data.end_date);
    _formData.append("workcenter", data.workcenter_id);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.put(baseUrl + "production-orders/" + id + "/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(response => {
      if (response.status === 200) {
        Swal.fire({
          title: "Production Order Updated",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });

        setTimeout(() => {
          navigate('/production-orders');
        }, 2000);
      }
    })
    .catch(() => Swal.fire("Error", "Update failed", "error"));
  };

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h4>Edit Production Order</h4>

        <input
          type="text"
          className="form-control mt-3"
          name="order_no"
          value={data.order_no}
          onChange={inputHandler}
          placeholder="Order No"
        />

        <select
          name="product_id"
          value={data.product_id}
          onChange={inputHandler}
          className="form-control mt-3"
        >
          <option value="">Select Product</option>
          {products.map(p => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
        </select>

        <input
          type="number"
          className="form-control mt-3"
          name="quantity"
          value={data.quantity}
          onChange={inputHandler}
          placeholder="Quantity"
        />

        <input
          type="date"
          className="form-control mt-3"
          name="start_date"
          value={data.start_date}
          onChange={inputHandler}
        />

        <input
          type="date"
          className="form-control mt-3"
          name="end_date"
          value={data.end_date}
          onChange={inputHandler}
        />

        <select
          name="workcenter_id"
          value={data.workcenter_id}
          onChange={inputHandler}
          className="form-control mt-3"
        >
          <option value="">Select Work Center</option>
          {WCs.map(wc => (
            <option key={wc.id} value={wc.id}>{wc.name}</option>
          ))}
        </select>

        <button className="btn btn-primary mt-3" onClick={formSubmit}>
          Update
        </button>
      </div>
    </div>
  );
}

export default EditProductionOrder;
